// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { OutboundLinkType, OutboundLink } from "../schema";

export function serialize_OutboundLink(obj: OutboundLink): string {
  const serialized = ((value: { id: bigint | null; meta: string; targetName: string | null; targetUrl: string; type: OutboundLinkType }): unknown => {
    return {
      id: ((value: bigint | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["id"]),
      meta: ((value: string): unknown => {
        return value;
      })(value["meta"]),
      targetName: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["targetName"]),
      targetUrl: ((value: string): unknown => {
        return value;
      })(value["targetUrl"]),
      type: ((value: "GENERIC" | "BUYBOOK" | "MIAB_SCHEDULE" | "ACTIONABLE_SCHEDULE"): unknown => {
        return value;
      })(value["type"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_OutboundLink(str: string): ParserResult<OutboundLink> {
  return ((
    value: unknown,
  ): ParserResult<{
    id: bigint | null;
    meta: string;
    targetName: string | null;
    targetUrl: string;
    type: OutboundLinkType;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/OutboundLink]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/OutboundLink]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/OutboundLink/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint | null> => {
      return ((value: unknown): ParserResult<bigint | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/OutboundLink/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "meta")) {
      return { success: false, reason: `[#/components/schemas/OutboundLink/meta]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'meta'.` };
    }
    const parsed_meta = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OutboundLink/meta]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["meta"]);
    })();
    if (!parsed_meta.success) {
      return { success: false, reason: parsed_meta.reason };
    }
    if (!hasProp(value, "targetName")) {
      return { success: false, reason: `[#/components/schemas/OutboundLink/targetName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'targetName'.` };
    }
    const parsed_targetName = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OutboundLink/targetName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["targetName"]);
    })();
    if (!parsed_targetName.success) {
      return { success: false, reason: parsed_targetName.reason };
    }
    if (!hasProp(value, "targetUrl")) {
      return { success: false, reason: `[#/components/schemas/OutboundLink/targetUrl]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'targetUrl'.` };
    }
    const parsed_targetUrl = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/OutboundLink/targetUrl]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["targetUrl"]);
    })();
    if (!parsed_targetUrl.success) {
      return { success: false, reason: parsed_targetUrl.reason };
    }
    if (!hasProp(value, "type")) {
      return { success: false, reason: `[#/components/schemas/OutboundLink/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
    }
    const parsed_type = ((): ParserResult<OutboundLinkType> => {
      return ((value: unknown): ParserResult<OutboundLinkType> => {
        return ((value: unknown): ParserResult<"GENERIC" | "BUYBOOK" | "MIAB_SCHEDULE" | "ACTIONABLE_SCHEDULE"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/OutboundLinkType]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "GENERIC":
              return { success: true, value: "GENERIC" };
            case "BUYBOOK":
              return { success: true, value: "BUYBOOK" };
            case "MIAB_SCHEDULE":
              return { success: true, value: "MIAB_SCHEDULE" };
            case "ACTIONABLE_SCHEDULE":
              return { success: true, value: "ACTIONABLE_SCHEDULE" };
            default:
              return { success: false, reason: `[#/components/schemas/OutboundLinkType]: '${value}' expected to be enum, one of 'GENERIC, BUYBOOK, MIAB_SCHEDULE, ACTIONABLE_SCHEDULE'.` };
          }
        })(value);
      })(value["type"]);
    })();
    if (!parsed_type.success) {
      return { success: false, reason: parsed_type.reason };
    }
    return { success: true, value: { id: parsed_id.value, meta: parsed_meta.value, targetName: parsed_targetName.value, targetUrl: parsed_targetUrl.value, type: parsed_type.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
